// LoginContext.js
import { createContext } from 'react';

const LoginContext = createContext();

export function LoginProvider({ value, children }) {
  return <LoginContext.Provider value={value}>{children}</LoginContext.Provider>;
}
export { LoginContext };
